export const dealOpenData =[
    {
        img:"10",
        title:"Cameron Williamson",
        subTitle:"Mi watch with jane",
        duration:"Clossing Date",
        date:"14 Jan 2023",
        amount:"$46.564",
        btn:"Contract Sent"
    },
    {
        img:"11",
        title:"Brooklyn Simmons",
        subTitle:"tree pot with jane",
        duration:"Clossing Date",
        date:"20 May 2023",
        amount:"$20.690",
        btn:"Contract Sent"
    },
    {
        img:"12",
        title:"Darlene Robertson",
        subTitle:"Wood Chair with jane",
        duration:"Clossing Date",
        date:"12 Aug 2023",
        amount:"$34.954",
        btn:"Contract Sent"
    },
    {
        img:"13",
        title:"Elipotion Zopnisde",
        subTitle:"Sneakers men with jane",
        duration:"Clossing Date",
        date:"16 Aug 2023",
        amount:"$12.954",
        btn:"Contract Sent"
    }
]

export const customersData=[
    {
       color:"primary",
       title:"Current Customer",
       count:"1500" 
    },
    {
        color:"secondary",
        title:"New Customer",
        count:"600" 
    },
    {
        color:"dark",
        title:"Old Customer",
        count:"900" 
    }
]